import { render, staticRenderFns } from "./ActivateProject.vue?vue&type=template&id=867cb596&"
import script from "./ActivateProject.vue?vue&type=script&lang=js&"
export * from "./ActivateProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports